import { defineStore } from 'pinia'

/**
 * Store for tracking typing status in dialogs
 * Stores information for each dialogId separately
 */
export const useTypingStore = defineStore('typing', {
  state: () => ({
    // Object with dialogId keys and true/false values (typing/not typing)
    typingStatus: {} as { [key: string]: boolean },
  }),
  
  actions: {
    /**
     * Sets typing status for a specific dialog
     * @param dialogId ID of the dialog
     * @param isTyping typing status (true = typing, false = not typing)
     */
    setTypingStatus(dialogId: string, isTyping: boolean) {
      this.typingStatus[dialogId] = isTyping
    },
    
    /**
     * Checks if the partner is typing in the specified dialog
     * @param dialogId ID of the dialog
     * @returns typing status (true = typing, false = not typing)
     */
    isTyping(dialogId: string): boolean {
      return this.typingStatus[dialogId] ?? false
    },
    
    /**
     * Starts typing in the specified dialog
     * @param dialogId ID of the dialog
     */
    startTyping(dialogId: string) {
      this.setTypingStatus(dialogId, true)
    },
    
    /**
     * Stops typing in the specified dialog
     * @param dialogId ID of the dialog
     */
    stopTyping(dialogId: string) {
      this.setTypingStatus(dialogId, false)
    }
  }
}) 